import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Button, createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { AuthPageWrapper, Icon } from '@app/components';
import { sharedMessages } from '@app/translations';
import { Route } from '@app/constants';

import { StepsBar } from '../StepsBar';

const cnBem = createBemBlockBuilder(['resetPin']);

export const ResetPinSuccess: FC = () => {
  const { $t } = useIntl();

  return (
    <AuthPageWrapper.Form data-auto="reset-pin-success">
      <StepsBar stepsAmount={3} currentStepIndex={2} />
      <div className={cnBem('__resetSuccess')}>
        <Icon icon={faCheckCircle} />
        <h2>
          {$t({
            id: 'resetPin.pinReset',
            defaultMessage: 'PIN reset',
          })}
        </h2>
        <div>
          {$t({
            id: 'resetPin.pinHasBeenReset',
            defaultMessage:
              'Your PIN has been reset. Please sign in with your new PIN.',
          })}
        </div>
        <Link to={Route.login}>
          <Button styleType="solid">{$t(sharedMessages.signIn)}</Button>
        </Link>
      </div>
    </AuthPageWrapper.Form>
  );
};
